import React from "react";
import { Box, Container, Divider, Typography } from "@mui/material";
import AboutNav from "../components/nav/AboutNav";
import WhySell from "../components/sellWithUs/whySell";
import SuccessStories from "../components/sellWithUs/successStories";
import Billing from "../components/sellWithUs/Billing";
import SellWithUsForm from "../components/sellWithUs/SellWithUsForm";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

function SellWithUs() {
  const history = useHistory();
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <>
      <AboutNav theme="dark" />
      <Box>
        <Box
          sx={{
            backgroundColor: { xs: "#fff", sm: "#283237" },
          }}
        >
          {mobMatch && (
            <ArrowBackIcon
              sx={{
                color: "primary.main",
                marginTop: "24px",
                marginLeft: "16px",
                alignSelf: "start",
              }}
              onClick={() => {
                history.goBack();
              }}
            />
          )}
          <Container
            disableGutters={true}
            sx={{
              width: "100%",
              height: { xs: "208px", sm: "292px" },
              color: { xs: "text.primary", sm: "#fff" },
              display: "flex",
              flexFlow: "column",
              alignItems: { sm: "center" },
              rowGap: { xs: "8px", sm: "24px" },
              textAlign: { xs: "start", sm: "center" },
              justifyContent: { xs: "end", sm: "center" },
              padding: { xs: "24px 16px", sm: "0px" },
              boxShadow: {
                xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
                sm: "none",
              },
              borderRadius: { xs: "0px 0px 8px 8px", sm: "0px" },
            }}
          >
            <Typography
              sx={{
                fontWeight: { xs: 600, sm: 700 },
                fontSize: { xs: "22px", sm: "48px" },
                lineHeight: { xs: "26px", sm: "52px" },
              }}
              variant={mobMatch ? "h3" : "h1"}
            >
              We find buyers for your machinery
            </Typography>
            <Typography
              sx={{
                color: { xs: "#616161", sm: "#D6D6D6" },
                fontWeight: 400,
                fontSize: { xs: "12px", sm: "16px" },
                lineHeight: { xs: "16px", sm: "24px" },
              }}
              variant={mobMatch ? "caption" : "body1"}
            >
              With Machinery Planet PRO, you can buy heavy machinery online and
              complete your purchase from the comfort of your desk. Choose from
              a wide list of Inspected machines with a money-back guarantee if
              the machinery you receive is not as advertised. Pay for your
              machinery through a secure and trusted channel,escrow.com (World’s
              no.1 escrow service).
            </Typography>
          </Container>
        </Box>
        <Container disableGutters={true}>
          <WhySell />
          <Divider
            sx={{
              color: "#D6D6D6",
            }}
          />
          <SuccessStories />
          <Divider
            sx={{
              color: "#D6D6D6",
            }}
          />
          <Billing />
          <Divider
            sx={{
              color: "#D6D6D6",
            }}
          />
          <SellWithUsForm />
        </Container>
      </Box>
    </>
  );
}

export default SellWithUs;
